import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Svg, Menu } from 'app/components';
import { onHoverBehavior } from 'app/utils';
import { SubList, LoggedWrapper } from '../styles';
import { useFontSize } from 'app/context/FontSizeRoute';
const propTypes = {
  userName: PropTypes.string
};

const defaultProps = {
  userName: null
};

export default function UserDropdown({ userName }) {
  const [t] = useTranslation();
  const { fontSize } = useFontSize();

  const [isFocused, setIsFocused] = useState(false);
  const wrapperRef = useRef();
  return (
    <LoggedWrapper
      fontSize={fontSize}
      chevron="true"
      tabIndex="0"
      onFocus={() => setIsFocused(true)}
      ref={wrapperRef}
      onBlur={e => {
        if (!wrapperRef.current?.contains(e.relatedTarget)) {
          setIsFocused(false);
        }
      }}
      {...onHoverBehavior}>
      <Svg id="user" />
      <span className="_with-chevron">{`${t('header.hello')}, ${userName || ''}`}</span>

      <SubList as="div" isVisible={isFocused}>
        <Menu isRounded />
      </SubList>
    </LoggedWrapper>
  );
};

UserDropdown.propTypes = propTypes;
UserDropdown.defaultProps = defaultProps;
